import { useState, useEffect } from 'react';
import { Button } from 'reactstrap';
import Drawer, { DrawerHeader, DrawerFooter } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { useForm, useActions } from 'utils/hooks';
import * as identifierActions from 'store/crew-identifiers/actions';
import { FormBody } from 'common/components/drawer';
import EditVisibilityForm from 'components/drawers/EditCompanyVisibility';
import selectDataFromState from 'utils/selectDataFromState';

import config from './identifier/config';
import CrewIdentifiers from './identifier';

const EditIdentifiers = ({ drawer, active, editType, refetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updateIdentifiers, createIdentifiers] = useActions([
    identifierActions.updateIdentifiers,
    identifierActions.createIdentifiers
  ]);
  const { formState, loadValues, handleSubmitError, resetForm, collectValues } = useForm(config);
  const { isOpen } = drawer;

  useEffect(() => {
    if (active && isOpen) {
      const params = {
        ...active,
        type: {
          type: active.type
        }
      };

      const initialValues = selectDataFromState(params, config);

      loadValues({ ...initialValues });
    }
    if (!isOpen) {
      resetForm();
    }
  }, [isOpen]);

  const submit = async () => {
    const values = collectValues();
    if (!values) return;

    const { type, ...rest } = values;

    const params = {
      ...rest,
      type: type.type,
      table: 'crew_identifiers',
      id: active ? active.id : undefined
    };

    setIsSubmitting(true);

    try {
      if (active) {
        await updateIdentifiers(params);
      } else {
        await createIdentifiers(params);
        resetForm();
        refetchData();
      }

      drawer.close();
    } catch (error) {
      handleSubmitError(error);
    }

    setIsSubmitting(false);
  };

  return active && editType === 'visibility' ? (
    <EditVisibilityForm
      drawer={drawer}
      active={active}
      isOpen={drawer.isOpen}
      type="enums/identifiers"
      table="crew_identifiers"
    />
  ) : (
    <Drawer {...drawer} className="table-drawer">
      <DrawerHeader className="border-bottom pb-4">
        {active ? 'Edit ' + active.name : 'Add New Identifier'}
      </DrawerHeader>

      <FormDrawer>
        <FormBody>
          <CrewIdentifiers formState={formState} />
        </FormBody>
      </FormDrawer>

      <DrawerFooter className="d-flex justify-content-end p-3">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => drawer.close()}
          disabled={isSubmitting}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={isSubmitting} color="primary" className="px-4">
          SAVE
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default EditIdentifiers;
